import { ModalBase } from "./base";

export default class extends ModalBase {
  connect() {
    this.element.show = () => this.show();
    this.element.close = () => this.close();
  }
}
